<template>
  <Modal
    v-model:show="active"
    class="modal-password profile__modal-change-password"
    @close="close"
  >
    <template v-slot:header>
      <h5 class="modal-title mr-8">
        {{ $t('profile.disableSecondFactor.title') }}
      </h5>
    </template>

    <UiInput
      v-model="model.password"
      v-model:error="errors_.password"
      class="mb-12"
      :label="$t('profile.disableSecondFactor.password')"
      type="password"
      placeholder="********"
      error-clear-on-change
    />
    <label class="label-sfa mt-8 mb-0"> {{ $t('profile.disableSecondFactor.token') }} <span>*</span> </label>
    <TfaCodeInput
      :key="active"
      v-model="model.token"
      :field-width="46"
      :field-height="46"
      @complete="onChange"
    />
    <div
      v-if="errors_.token"
      class="text-danger error-style wrongPassword"
    >
      {{ errors_.token[0].message }}
    </div>
    
    <template v-slot:footer>
      <div class="m-0">
        <button
          class="btn btn-primary btn-sm !tw-block !tw-w-full mt-8 mb-8"
          :disabled="!model.password
            || !model.token
            || model.token.length !== 6
            || isLoading"
          @click="pass"
        >
          {{ $t('profile.disableSecondFactor.disable') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import TfaCodeInput from '@/components/ui/TfaCodeInput.vue';


export default {
  components: {
    Modal,
    TfaCodeInput,
  },
  data() {
    return {
      isLoading: false,
      active: false,
      callback: new Function(),
      // typeCode: 'bc',
      model: {
        password: '',
        token: '',
      },
      passwordShown: false,
      errors_: {},
    };
  },

  methods: {
    open(cb) {
      this.active = true;
      this.callback = cb || new Function();
      this.model.password = '';
      this.model.token = '';
      this.errors_ = {};
    },
    pass() {
      this.isLoading = true;
      this.$store
        .dispatch('otpDisable', { ...this.model })
        .then(() => {
          this.$alert.success(this.$t('profile.secondFactor.googleAuthdisabled'));
          this.active = false;
        })
        .catch((err) => {
          this.errors_ = err.response.data.errors;
          this.$alert.error(err.response.data.message, () => {});
        })
        .finally(() => this.isLoading = false);
    },
    onChange() {
      // this.model.token = this.$refs.codeinput.values.reduce((a, b) => a.concat(b), '');
      this.errors_.token = '';
    },
    close() {
      this.model.password = '';
      this.model.token = '';
      this.errors_ = {};
      this.active = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal__password {
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 7px;
  font-size: 13px;
  span {
    color: #f66;
  }
}
.password {
  position: relative;
  i {
    position: absolute;
    right: 5px;
    top: 50%;
    opacity: 0.3;
    transform: translateY(-50%);
  }
}
</style>
